import { useContext, useEffect, useState } from "react";
import FormField from "../../../../components/formField/formField";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import PoFormContext from "../../../../contexts/poFormContext";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { padZeros } from "../../../../helpers/idNumber";
import { prepareGminy } from "../../../../helpers/form";
import { createConfigValidation } from "../../../../helpers/validation/validation";

const RegistrationNumber = (props: any) => { 
    const { poForm } = useContext(PoFormContext);
    const [errorTipText, setErrorTipText] = useState("");
    const [reload, setReload] = useState(false);

    // Validation
    useEffect(() => {
        if (poForm.config?.check && !poForm.config.isValid) {
            var errorMsg = poForm.config?.ValidationError!["obiekT_NUMER_IDENTYFIKACYJNY"]
            if (errorMsg !== '') {
                setErrorTipText(errorMsg);
                setReload(!reload);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poForm.config?.check])

    // Registration number for protocol
    // Registration number for landslide / endangered area
    var idNumber: number | string | undefined = "";

    if (poForm.protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY)
        idNumber = padZeros(poForm.protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY as number);

        const createValueRegistrationNumber = () => {
        var registrationNumber = "";
        if (poForm.landslideGminy != null && poForm.landslideGminy.length > 0) {
            poForm.landslideGminy?.sort((a, b) => {
                if (a.kolejnosc !== undefined && a.kolejnosc != null && b.kolejnosc != null && b.kolejnosc !== undefined) {
                    return b.kolejnosc - a.kolejnosc;
                }
                return 0;
            });
            poForm.landslideGminy?.forEach((value, index) => {
                if (index === 0) registrationNumber += `${prepareGminy(value.teryt)}-${idNumber}`;
                else registrationNumber += `,\n${prepareGminy(value.teryt)}-${idNumber}`;
            });            
        }
        else if (poForm.endangeredAreaGminy != null && poForm.endangeredAreaGminy.length > 0) {
            poForm.endangeredAreaGminy?.sort((a, b) => {
                if (a.kolejnosc !== undefined && a.kolejnosc != null && b.kolejnosc != null && b.kolejnosc !== undefined) {
                    return b.kolejnosc - a.kolejnosc;
                }
                return 0;
            });
            poForm.endangeredAreaGminy?.forEach((value, index) => {
                if (index === 0) registrationNumber += `${prepareGminy(value.teryt)}-${idNumber}`;
                else registrationNumber += `,\n${prepareGminy(value.teryt)}-${idNumber}`;
            });
        }
        return registrationNumber;
    }

    var registrationNumber = createValueRegistrationNumber();

    const getInputProps = (label: string): FormFieldProps => {
        return {
            labelName: label,
            value: registrationNumber,
            style: styleFormFieldHalf,
            type: "text",
            configValidation: createConfigValidation("onlyRequired", true),
            disabled: true,
            hasTextarea: true,
            validationError: poForm.config?.isValid !== undefined ? !poForm.config?.isValid : false,
            tipText: errorTipText,
            reload: reload
        }
    }

    return (
        <div>
            <h2>1. Numer ewidencyjny</h2>
            <div style={{display: "flex", columnGap: "2%", justifyContent: "space-between"}}>
                <FormField {...getInputProps('Numer ewidencyjny protokołu obserwacji')} />
                <FormField {...getInputProps(`Numer ewidencyjny ${props.isLandslide ? "osuwiska" : "terenu zagrożonego"}`)} />   
            </div>                   
        </div>
    )
}

export default RegistrationNumber;